import React from 'react';
import classNames from 'classnames/bind';
import styles from './styles.module.scss';

const cx = classNames.bind(styles);

function IconButton({ children, className, ...props }) {
  return (
    <div className={cx('IconButton', className)} {...props}>
      {children}
    </div>
  );
}

export default IconButton;
